/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.12.1.0 (NJsonSchema v10.4.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class Client {
	private http: {
		fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
	};
	private baseUrl: string;
	private customerName: string | null;
	private token: string | null;

	protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
		undefined;

	constructor(
		baseUrl?: string,
		http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
	) {
		this.http = http ? http : <any>window;
		this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
		this.customerName = "";
		if (sessionStorage.getItem("customer")) {
			this.customerName = sessionStorage.getItem("customer");
		}

		this.token = "";
		if (sessionStorage.getItem("token")) {
			this.token = sessionStorage.getItem("token");
		}
	}

	/**
	 * @return Success
	 */
	platformsAll(base: boolean, model?: string): Promise<string[]> {
		let url_ = this.baseUrl + "/api/" + this.customerName + "/platforms";

		if (base) {
			url_ += "/base";
		}

		url_ = url_.replace(/[?&]$/, "");

		if (model && model !== "") {
			url_ += "?model=" + model;
		}

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processPlatformsAll(_response);
		});
	}

	protected processPlatformsAll(response: Response): Promise<string[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200) {
			return response.text().then((_responseText) => {
				let result200: any = null;
				let resultData200 =
					_responseText === ""
						? null
						: JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200) result200!.push(item);
				} else {
					result200 = <any>null;
				}
				return result200;
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<string[]>(<any>null);
	}

	/**
	 * @return Success
	 */
	prefix(
		platformName: string,
		base: boolean,
		model?: string
	): Promise<string[]> {
		let url_ =
			this.baseUrl + "/api/" + this.customerName + "/{platformName}/prefix";

		if (base) {
			url_ += "/base";
		}

		if (platformName === undefined || platformName === null)
			throw new Error("The parameter 'platformName' must be defined.");
		url_ = url_.replace(
			"{platformName}",
			encodeURIComponent("" + platformName)
		);
		url_ = url_.replace(/[?&]$/, "");

		if (model && model !== "") {
			url_ += "?model=" + model;
		}

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processPrefix(_response);
		});
	}

	protected processPrefix(response: Response): Promise<string[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200) {
			return response.text().then((_responseText) => {
				let result200: any = null;
				let resultData200 =
					_responseText === ""
						? null
						: JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200) result200!.push(item);
				} else {
					result200 = <any>null;
				}
				return result200;
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<string[]>(<any>null);
	}

	/**
	 * @return Success
	 */
	model(
		platformName: string,
		prefixName: string,
		base: boolean,
		model?: string
	): Promise<string[]> {
		let url_ =
			this.baseUrl +
			"/api/" +
			this.customerName +
			"/{platformName}/{prefixName}/model";

		if (base) {
			url_ += "/base";
		}

		if (platformName === undefined || platformName === null)
			throw new Error("The parameter 'platformName' must be defined.");
		url_ = url_.replace(
			"{platformName}",
			encodeURIComponent("" + platformName)
		);
		if (prefixName === undefined || prefixName === null)
			throw new Error("The parameter 'prefixName' must be defined.");
		url_ = url_.replace("{prefixName}", encodeURIComponent("" + prefixName));
		url_ = url_.replace(/[?&]$/, "");

		if (model && model !== "") {
			url_ += "?model=" + model;
		}

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processModel(_response);
		});
	}

	protected processModel(response: Response): Promise<string[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200) {
			return response.text().then((_responseText) => {
				let result200: any = null;
				let resultData200 =
					_responseText === ""
						? null
						: JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200) result200!.push(item);
				} else {
					result200 = <any>null;
				}
				return result200;
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<string[]>(<any>null);
	}

	/**
	 * @return Success
	 */
	platforms(
		platformName: string,
		prefixName: string,
		modelName: string,
		base: boolean
	): Promise<ModelPriceData> {
		let url_ =
			this.baseUrl +
			"/api/" +
			this.customerName +
			"/{platformName}/{prefixName}/{modelName}";

		if (base) {
			url_ += "/base";
		}
		if (platformName === undefined || platformName === null)
			throw new Error("The parameter 'platformName' must be defined.");
		url_ = url_.replace(
			"{platformName}",
			encodeURIComponent("" + platformName)
		);
		if (prefixName === undefined || prefixName === null)
			throw new Error("The parameter 'prefixName' must be defined.");
		url_ = url_.replace("{prefixName}", encodeURIComponent("" + prefixName));
		if (modelName === undefined || modelName === null)
			throw new Error("The parameter 'modelName' must be defined.");
		url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
		url_ = url_.replace(/[?&]$/, "");

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processPlatforms(_response);
		});
	}

	protected processPlatforms(response: Response): Promise<ModelPriceData> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200) {
			return response.text().then((_responseText) => {
				let result200: any = null;
				let resultData200 =
					_responseText === ""
						? null
						: JSON.parse(_responseText, this.jsonParseReviver);
				result200 = ModelPriceData.fromJS(resultData200);
				return result200;
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<ModelPriceData>(<any>null);
	}

	/**
	 * @return Success
	 */
	csv(
		platformName: string,
		prefixName: string,
		modelName: string,
		version: string
	): Promise<FileResponse> {
		let url_ =
			this.baseUrl +
			"/api/" +
			this.customerName +
			"/{platformName}/{prefixName}/{modelName}/{version}/csv";
		if (platformName === undefined || platformName === null)
			throw new Error("The parameter 'platformName' must be defined.");
		url_ = url_.replace(
			"{platformName}",
			encodeURIComponent("" + platformName)
		);
		if (prefixName === undefined || prefixName === null)
			throw new Error("The parameter 'prefixName' must be defined.");
		url_ = url_.replace("{prefixName}", encodeURIComponent("" + prefixName));
		if (modelName === undefined || modelName === null)
			throw new Error("The parameter 'modelName' must be defined.");
		url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
		if (version === undefined || version === null)
			throw new Error("The parameter 'version' must be defined.");
		url_ = url_.replace("{version}", encodeURIComponent("" + version));
		url_ = url_.replace(/[?&]$/, "");

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processCsv(_response);
		});
	}

	protected processCsv(response: Response): Promise<FileResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200 || status === 206) {
			const contentDisposition = response.headers
				? response.headers.get("Content-Disposition")
				: undefined;
			const fileNameMatch = contentDisposition
				? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
				: undefined;
			const fileName =
				fileNameMatch && fileNameMatch.length > 1
					? fileNameMatch[1]
					: undefined;
			return response.blob().then((blob) => {
				return {
					fileName: fileName,
					data: blob,
					status: status,
					headers: _headers,
				};
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<FileResponse>(<any>null);
	}

	
	/**
	 * @return Success
	 */
	 zip(): Promise<FileResponse> {
		let url_ =
			this.baseUrl +
			"/api/" +
			this.customerName +
			"/zip";
		url_ = url_.replace(/[?&]$/, "");

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processZip(_response);
		});
	}

	protected processZip(response: Response): Promise<FileResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200 || status === 206) {
			const contentDisposition = response.headers
				? response.headers.get("Content-Disposition")
				: undefined;
			const fileNameMatch = contentDisposition
				? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
				: undefined;
			const fileName =
				fileNameMatch && fileNameMatch.length > 1
					? fileNameMatch[1]
					: undefined;
			return response.blob().then((blob) => {
				return {
					fileName: fileName,
					data: blob,
					status: status,
					headers: _headers,
				};
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<FileResponse>(<any>null);
	}

	/**
	 * @param modelName (optional)
	 * @param minWidth (optional)
	 * @param maxWidth (optional)
	 * @param minHeight (optional)
	 * @param maxHeight (optional)
	 * @param minPrice (optional)
	 * @param maxPrice (optional)
	 * @return Success
	 */
	search(
		modelName: string | undefined,
		minWidth: number | undefined,
		maxWidth: number | undefined,
		minHeight: number | undefined,
		maxHeight: number | undefined,
		minPrice: number | undefined,
		maxPrice: number | undefined
	): Promise<string[]> {
		let url_ = this.baseUrl + "/api/" + this.customerName + "/search?";
		if (modelName === null)
			throw new Error("The parameter 'modelName' cannot be null.");
		else if (modelName !== undefined)
			url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
		if (minWidth === null)
			throw new Error("The parameter 'minWidth' cannot be null.");
		else if (minWidth !== undefined)
			url_ += "minWidth=" + encodeURIComponent("" + minWidth) + "&";
		if (maxWidth === null)
			throw new Error("The parameter 'maxWidth' cannot be null.");
		else if (maxWidth !== undefined)
			url_ += "maxWidth=" + encodeURIComponent("" + maxWidth) + "&";
		if (minHeight === null)
			throw new Error("The parameter 'minHeight' cannot be null.");
		else if (minHeight !== undefined)
			url_ += "minHeight=" + encodeURIComponent("" + minHeight) + "&";
		if (maxHeight === null)
			throw new Error("The parameter 'maxHeight' cannot be null.");
		else if (maxHeight !== undefined)
			url_ += "maxHeight=" + encodeURIComponent("" + maxHeight) + "&";
		if (minPrice === null)
			throw new Error("The parameter 'minPrice' cannot be null.");
		else if (minPrice !== undefined)
			url_ += "minPrice=" + encodeURIComponent("" + minPrice) + "&";
		if (maxPrice === null)
			throw new Error("The parameter 'maxPrice' cannot be null.");
		else if (maxPrice !== undefined)
			url_ += "maxPrice=" + encodeURIComponent("" + maxPrice) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_ = <RequestInit>{
			method: "GET",
			headers: {
				Accept: "text/plain",
				Authorization: "Bearer " + this.token,
			},
		};

		return this.http.fetch(url_, options_).then((_response: Response) => {
			return this.processSearch(_response);
		});
	}

	protected processSearch(response: Response): Promise<string[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => (_headers[k] = v));
		}
		if (status === 200) {
			return response.text().then((_responseText) => {
				let result200: any = null;
				let resultData200 =
					_responseText === ""
						? null
						: JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200) result200!.push(item);
				} else {
					result200 = <any>null;
				}
				return result200;
			});
		} else if (status !== 200 && status !== 204) {
			return response.text().then((_responseText) => {
				return throwException(
					"An unexpected server error occurred.",
					status,
					_responseText,
					_headers
				);
			});
		}
		return Promise.resolve<string[]>(<any>null);
	}
}

export class ModelPriceData implements IModelPriceData {
	platform?: string | undefined;
	prefix?: string | undefined;
	model?: string | undefined;
	pictures: PictureInfo[];
	priceTables?: PriceTables[] | undefined;

	constructor(data?: IModelPriceData) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
		this.pictures = [];
	}

	init(_data?: any) {
		if (_data) {
			this.platform = _data["platform"];
			this.prefix = _data["prefix"];
			this.model = _data["model"];
			if (Array.isArray(_data["pictures"])) {
				this.pictures = [] as any;
				for (let item of _data["pictures"])
					this.pictures!.push(PictureInfo.fromJS(item));
			}
			if (Array.isArray(_data["priceTables"])) {
				this.priceTables = [] as any;
				for (let item of _data["priceTables"])
					this.priceTables!.push(PriceTables.fromJS(item));
			}
		}
	}

	static fromJS(data: any): ModelPriceData {
		data = typeof data === "object" ? data : {};
		let result = new ModelPriceData();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === "object" ? data : {};
		data["platform"] = this.platform;
		data["prefix"] = this.prefix;
		data["model"] = this.model;
		if (Array.isArray(this.pictures)) {
			data["pictures"] = [];
			for (let item of this.pictures) data["pictures"].push(item.toJSON());
		}
		if (Array.isArray(this.priceTables)) {
			data["priceTables"] = [];
			for (let item of this.priceTables)
				data["priceTables"].push(item.toJSON());
		}
		return data;
	}
}

export interface IModelPriceData {
	platform?: string | undefined;
	prefix?: string | undefined;
	model?: string | undefined;
	pictures: PictureInfo[];
	priceTables?: PriceTables[] | undefined;
}

export class PictureInfo implements IPictureInfo {
	rowId?: string;
	modelName?: string;
	imageData?: string;

	constructor(data?: IPictureInfo) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.rowId = _data["rowId"];
			this.modelName = _data["modelName"];
			this.imageData = _data["imageData"];
		}
	}

	static fromJS(data: any): PictureInfo {
		data = typeof data === "object" ? data : {};
		let result = new PictureInfo();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === "object" ? data : {};
		data["rowId"] = this.rowId;
		data["modelName"] = this.modelName;
		data["imageData"] = this.imageData;
		return data;
	}
}

export class PriceTables implements IPriceTables {
	name?: string;
	versionName?: string;
	heights?: number[];
	widths?: number[];
	prices?: number[][];

	constructor(data?: IPriceTables) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.name = _data["name"];
			this.versionName = _data["versionName"];
			if (Array.isArray(_data["heights"])) {
				this.heights = [] as any;
				for (let item of _data["heights"]) this.heights!.push(item);
			}
			if (Array.isArray(_data["widths"])) {
				this.widths = [] as any;
				for (let item of _data["widths"]) this.widths!.push(item);
			}
			if (Array.isArray(_data["prices"])) {
				this.prices = [] as any;
				for (let item of _data["prices"]) this.prices!.push(item);
			}
		}
	}

	static fromJS(data: any): PriceTables {
		data = typeof data === "object" ? data : {};
		let result = new PriceTables();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === "object" ? data : {};
		data["name"] = this.name;
		data["versionName"] = this.versionName;
		if (Array.isArray(this.heights)) {
			data["heights"] = [];
			for (let item of this.heights) data["heights"].push(item);
		}
		if (Array.isArray(this.widths)) {
			data["widths"] = [];
			for (let item of this.widths) data["widths"].push(item);
		}
		if (Array.isArray(this.prices)) {
			data["prices"] = [];
			for (let item of this.prices) data["prices"].push(item);
		}
		return data;
	}
}

export interface IPriceTables {
	name?: string;
	heights?: number[];
	widths?: number[];
	prices?: number[][];
}

export interface IPictureInfo {
	rowId?: string;
	modelName?: string;
	imageData?: string;
}

export interface FileResponse {
	data: Blob;
	status: number;
	fileName?: string;
	headers?: { [name: string]: any };
}

export class ApiException extends Error {
	message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(
		message: string,
		status: number,
		response: string,
		headers: { [key: string]: any },
		result: any
	) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isApiException = true;

	static isApiException(obj: any): obj is ApiException {
		return obj.isApiException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new ApiException(message, status, response, headers, null);
}

//@ts-ignore
export class PriceGridClient extends Client {
	constructor() {
		super(process.env.REACT_APP_PRICE_GRID_API_URL, undefined);
	}
}
